import { render, staticRenderFns } from "./Shouye.vue?vue&type=template&id=3bf6168b&scoped=true&"
import script from "./Shouye.vue?vue&type=script&lang=js&"
export * from "./Shouye.vue?vue&type=script&lang=js&"
import style0 from "./Shouye.vue?vue&type=style&index=0&id=3bf6168b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf6168b",
  null
  
)

export default component.exports